import React from "react";
import { Col, Row } from "react-bootstrap";
import classes from "./LogoutModal.module.css";
import { Button } from "../../Component/Button/Button";
import ModalSkeleton from "../ModalSkeleton";

const LogoutModal = ({ show, setShow, logout }) => {

  const handleLogout = () => {
    logout();
    setShow(false);
  };

  return (
    <>
      <style>{`
    .modal-content{
      border-radius:16px !important;
    }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        modalClass={[classes.loginModal]}
        width={"752px"}
      >
        <Row>
          <Col md={12}>
            <div className={classes.loginText}>
              <h3>Are you sure?</h3>
            </div>
          </Col>
          <Col md={12}>
            <div className={[classes.inputCol]}>

            </div>
            <Button
              className={classes.loginBtn}
              label="Log out"
              onClick={() => handleLogout()}
            />
          </Col>
        </Row>
      </ModalSkeleton>
    </>
  );
};

export default LogoutModal;
